import React from 'react';
import { BoardingPetTypeStep } from 'components/Boarding/Form/Steps/PetType/BoardingPetTypeStep';
import { PetType } from '@spike/model';
import Service from 'model/Service';

interface Props {
    selectedPetTypes: Array<PetType>;
    marketplaces?: Service['marketplaces'];
    serviceId?: number;
    onNext: (petTypes: Array<PetType>, marketplaces?: Service['marketplaces']) => void;
}

export const TrainingPetTypeStep: React.FC<Props> = props => (
    <BoardingPetTypeStep
        {...props}
        serviceCategory="training"
    />
);
